import { Box, Radio, Typography } from '@mui/material';
import { useMemo, useState } from 'react';
import { SearchInput } from '@/shared/ui';
import type { SavedPresetRecord } from '../../model/types';
import { SavedPresetItem } from '../SavedPresetItem/SavedPresetItem';

interface Props {
  presets: SavedPresetRecord[];
  value?: SavedPresetRecord;
  onChange: (preset: SavedPresetRecord) => void;
}

export function SelectPreset({ presets, value, onChange }: Readonly<Props>) {
  const [searchQuery, setSearchQuery] = useState('');

  const filteredPresets = useMemo(() => {
    if (!searchQuery) return presets;
    const q = searchQuery.toLowerCase();
    return presets.filter((p) => p.name.toLowerCase().includes(q));
  }, [presets, searchQuery]);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
      <SearchInput
        query={searchQuery}
        onChange={setSearchQuery}
        placeholder="Search presets"
      />
      <Box
        sx={{
          maxHeight: 200,
          overflowY: 'auto',
        }}
      >
        {filteredPresets.length === 0 ? (
          <Typography variant="body2" color="text.secondary" sx={{ p: 1.5 }}>
            No presets found.
          </Typography>
        ) : (
          filteredPresets.map((preset) => (
            <SavedPresetItem
              key={preset.id}
              sx={{ pl: 0, py: 0.5 }}
              leftSlot={
                <Radio
                  size="small"
                  checked={value?.id === preset.id}
                  onChange={() => onChange(preset)}
                  sx={{ p: 0.125, ml: 0.5, flexShrink: 0, alignSelf: 'center' }}
                />
              }
              presetRecord={preset}
              onClick={onChange}
            />
          ))
        )}
      </Box>
    </Box>
  );
}
